<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-form-text-input v-model="filters.name" placeholder="Nombre"></app-form-text-input>
            </b-col>
            <b-col>
                <app-date-picker v-model="filters.from" placeholder="Desde"></app-date-picker>
            </b-col>
            <b-col>
                <app-date-picker v-model="filters.to" placeholder="Hasta"></app-date-picker>
            </b-col>
            <b-col>
                <b-checkbox v-model="filters.onlyLeft" unchecked-value="" :value="1">Pendientes</b-checkbox>
            </b-col>
            <b-col>
                <b-btn variant="primary" @click="filter"><i class="fa fa-filter"></i></b-btn>
                <b-btn variant="secondary" @click="reset"><i class="fa fa-times"></i></b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        filters: {
            name: '',
            from: '',
            to: '',
            onlyLeft: ''
        }
    }),
    methods: {
        reset() {
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', this.filters);
        },
        filter() {
            this.$emit('filter', this.filters);
        }
    }
}
</script>